import React from "react";

const DeliveryPolicy = () => {
  return (
    <div className="w-full bg-gray-500" style={{ padding: "40px" }}> 
<div className="mx-auto px-8 sm:px-12 md:px-16 lg:px-24" > 
        <h1 className="text-3xl font-bold">DELIVERY POLICY</h1>

        <p>
          This Delivery Policy ("Policy") describes how <strong>FinReliable Technology IMF Private Limited</strong>, doing business as <strong>FinReliable Technology IMF</strong>, delivers its insurance related services via our portal ("Website") available at <a href="https://www.finrelinsure.com" className="underline text-blue-600">https://www.finrelinsure.com</a>. By using our insurance related services, you ("User", "you", or "your") agree to the terms set forth in this Policy in addition to our other policies and Terms & Conditions. If you do not agree to these Terms, please do not access or use our services.
        </p>

        <h2 className="text-2xl font-semibold mt-8">1. SCOPE OF SERVICE DELIVERY</h2>

        <p className="font-semibold">Digital Service Environment:</p>
        <p>
          All insurance related services (car insurance, bike insurance, health insurance, travel insurance, home insurance, and related services provided via our website) are digital in nature. This includes the issuance, activation, management, and maintenance of your insurance account, as well as the processing of insurance transactions.
        </p>

        <p className="font-semibold">Service Components:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Account Setup & Management:</strong> Registration, activation, and ongoing management of your insurance service account.</li>
          <li><strong>Transaction Processing:</strong> Facilitation for insurance policy, including insurance premium transactions.</li>
          <li><strong>Notifications and Alerts:</strong> Delivery of transaction confirmations, alerts, and service updates via email and/or SMS.</li>
          <li><strong>Support Services:</strong> Access to online resources such as FAQs, user guides, and customer support channels for troubleshooting and assistance.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">2. SERVICE DELIVERY AND ACCESS</h2>

        <p className="font-semibold">Account Activation:</p>
        <p>
          Upon successful registration and completion of any necessary verification and payment steps, you will receive activation details for your insurance. Access credentials and usage instructions will be sent to your registered email address.
        </p>

        <p className="font-semibold">Real-Time Transaction Processing:</p>
        <p>
          Once your account is active, insurance premium transactions are processed in real time. Transaction status and receipts are available on your account dashboard and via notifications.
        </p>

        <p className="font-semibold">Delivery of Notifications:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Email to your registered email address.</li>
          <li>SMS to your registered mobile number.</li>
        </ul>

        <p className="font-semibold">Access to Support Resources:</p>
        <p>
          User guides, FAQs, troubleshooting tips, and other support materials are available on the Website to assist you in using our insurance related services effectively.
        </p>

        <h2 className="text-2xl font-semibold mt-8">3. TECHNICAL REQUIREMENTS AND USER RESPONSIBILITIES</h2>

        <p className="font-semibold">Technical Requirements:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>A stable internet connection.</li>
          <li>A modern, up-to-date web browser (such as the latest versions of Chrome, Firefox, Safari, or Edge).</li>
          <li>Compatibility with our Website and any integrated third-party payment gateways.</li>
        </ul>

        <p className="font-semibold">User Responsibilities:</p>
        <p>
          It is your responsibility to ensure that your device's software and hardware are compatible with our website. You must also maintain the confidentiality of your account credentials and ensure that your registered contact information is accurate to receive notifications.
        </p>

        <h2 className="text-2xl font-semibold mt-8">4. SERVICE AVAILABILITY, MAINTENANCE, AND DISRUPTIONS</h2>

        <p className="font-semibold">Availability:</p>
        <p>
          We strive to keep our Website and services available 24/7. However, scheduled maintenance, software updates, or unforeseen technical issues may occasionally affect service availability.
        </p>

        <p className="font-semibold">Scheduled Maintenance:</p>
        <p>
          When possible, we will notify registered users in advance of any scheduled maintenance that might temporarily interrupt access to the services.
        </p>

        <p className="font-semibold">Unforeseen Disruptions:</p>
        <p>
          In the event of unexpected service interruptions (e.g., due to network issues, technical failures, or third-party service outages), we will work promptly to restore full functionality. Users are encouraged to report persistent issues to our support team at <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>.
        </p>

        <p className="font-semibold">Third-Party Dependencies:</p>
        <p>
          Our insurance services may rely on third-party payment processors or platforms. While we strive to ensure seamless integration, we are not responsible for disruptions caused by these third parties.
        </p>

        <h2 className="text-2xl font-semibold mt-8">5. MODIFICATIONS TO SERVICE DELIVERY</h2>
        <p>
          FinReliable Technology IMF reserves the right to update, modify, or improve our service delivery methods, account features, or support resources at any time. Significant changes that could affect your service experience will be communicated via email and posted on the Website.
        </p>

        <h2 className="text-2xl font-semibold mt-8">6. RESOLUTION OF DELIVERY ISSUES</h2>
        <p>
          If you experience difficulties accessing or using our insurance related services, please contact our support team immediately at <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>. Provide as much detail as possible (e.g., error messages, screenshots, time of occurrence) to facilitate a timely resolution. Our support team aims to respond within 24-48 hours on business days.
        </p>

        <h2 className="text-2xl font-semibold mt-8">7. LIMITATION OF LIABILITY</h2>
        <p>
          While we strive for uninterrupted service, <strong>FinReliable Technology IMF Private Limited</strong> shall not be held liable for any delays or interruptions in service delivery due to factors beyond our control (including force majeure events, technical failures, or issues with third-party services).
        </p>

        <h2 className="text-2xl font-semibold mt-8">8. CONTACT INFORMATION</h2>
        <p>
          For any questions or concerns regarding this Delivery Policy, please contact us at: <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>.
        </p>
      </div>
    </div>
  );
};

export default DeliveryPolicy;
